import React from 'react';
import DefaultOutlet from 'routes/DefaultOutlet';
import { itemCodeEventsRoutes as itemRoutes } from './constants';
import CodeEventContainer from './containers/CodeEventContainer';

interface IProps { }
export const routes = {
  path: itemRoutes.codeevent,
  element: <DefaultOutlet />,
  children: [
    { index: true, element: <CodeEventContainer /> },

  ],
}
const ItemBatchIndex: React.FC<IProps> = () => {
  return (
    <DefaultOutlet />

  );
};

export default ItemBatchIndex;
